import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, catchError, of, tap } from 'rxjs';
import { APIResponse, ForgotPasswordResponse, Login, LoginResponse, UserLocalStorageData } from '../../types-enums/types/authentication';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EncryptDecrypt } from '../../utils/encrypt-decrypt';

@Injectable({
     providedIn: 'root',
})

export class AuthService {
     public isAuth = new BehaviorSubject<boolean>(false);

     constructor(
          private router: Router,
          private http: HttpClient
     ) {
          this.autoSignIn();
     }

     autoSignIn() {
          if (!localStorage.getItem('gvaSystem')) {
               this.isAuth.next(false);
               return of(null);
          }
          const userData: UserLocalStorageData = JSON.parse(EncryptDecrypt.decryptWithKey(localStorage.getItem('gvaSystem')));
          if (!userData?.session_id && userData?.session_id == '') {
               this.isAuth.next(false);
               return of(null);
          } else {
               this.isAuth.next(true);
               return of(true);
          }
     }

     signIn(payLoad: Login): Observable<LoginResponse> {
          const url = environment.gatewayURL + 'auth-token/'
          return this.http.post<LoginResponse>(url, payLoad, { withCredentials: true }).pipe(
               tap((response: LoginResponse) => {
               }),
               catchError(error => {
                    throw error;
               })
          );
     }

     resetPassword(params: HttpParams): Observable<ForgotPasswordResponse> {
          var url = environment.userManagement + 'forgot_password/';
          return this.http.get<ForgotPasswordResponse>(url, {params}).pipe(
               tap((data: ForgotPasswordResponse) => {
               }),
               catchError(error => {
                    throw error;
               })
          );
     }

     sessionCleanup(params: HttpParams): Observable<APIResponse>  {
          localStorage.removeItem('gvaSystem');
          this.isAuth.next(false);
          const url = environment.gatewayURL + 'session-cleanup/';
          return this.http.get<APIResponse>(url, {params}).pipe(
               tap((data: APIResponse) => {
               }),
               catchError(error => {
                    throw error;
               })
          );
     }

     signOut() {
          const url = environment.gatewayURL + 'logout/';
          return this.http.get<APIResponse>(url).pipe(
               tap((data: APIResponse) => {
               }),
               catchError(error => {
                    throw error;
               })
          );
     }
}